"use strict";
/*
 * Created on 09 03 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductPreferredSupplier_1 = require("../model/ProductPreferredSupplier");

var ProductPreferredSupplierConverter_1 = require("./ProductPreferredSupplierConverter");
/**
 * Implementation of {@link ProductPreferredSupplierConverter}.
 *
 * @author JMe
 */


var ProductPreferredSupplierConverterImpl =
/*#__PURE__*/
function (_ProductPreferredSupp) {
  _inherits(ProductPreferredSupplierConverterImpl, _ProductPreferredSupp);

  function ProductPreferredSupplierConverterImpl() {
    _classCallCheck(this, ProductPreferredSupplierConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPreferredSupplierConverterImpl).apply(this, arguments));
  }

  _createClass(ProductPreferredSupplierConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        processed: source.processed
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ProductPreferredSupplier_1.ProductPreferredSupplier(conversions.documentToClassId(source), conversions.asObject(source, 'productId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'supplierId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'processed', function (v) {
        return v;
      }));
    }
  }]);

  return ProductPreferredSupplierConverterImpl;
}(ProductPreferredSupplierConverter_1.ProductPreferredSupplierConverter);

exports.ProductPreferredSupplierConverterImpl = ProductPreferredSupplierConverterImpl;